var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout",staticStyle:{"margin-top":"50px"}},_vm._l((_vm.listHonors),function(item,index){return _c('div',{key:`${item.name + index + item.title}`},[_c('CardOKRItem',{attrs:{"okr-item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }